import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { IFilterState } from '../../types/stateTypes/stateTypes';
import { Common } from '../../utils/constants';
import { Can } from '../../ability';
import DriverDebtContent from './DriverDebtContent';
import { companyNameReplace } from '../../utils';

const DriverDebt = () => {
    const { t } = useTranslation();
    const [filterState, setFilterState] = useState<IFilterState>({
        rowsPerPage: 10,
        currentPage: 1,
        sortColumn: 'creation_date_time',
        sortOrder: 'desc',
        offset: 0,
    });
    const [pastLettersFilterState, setPastLettersFilterState] = useState<IFilterState>({
        rowsPerPage: 10,
        currentPage: 1,
        sortColumn: 'creation_date_time',
        sortOrder: 'desc',
        offset: 0,
    });

    return (
        <>
            <Helmet>
                <title>{companyNameReplace(t('driverDebt.title'))}</title>
            </Helmet>
            <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.DRIVERS.DRIVER_DEBT}>
                <DriverDebtContent
                    updateFilterState={setFilterState}
                    filterState={filterState}
                    updatePLFilterState={setPastLettersFilterState}
                    pastLettersFilterState={pastLettersFilterState}
                />
            </Can>
        </>
    );
};

export default DriverDebt;
